// ============================================================================
// Personal-snippet API — wraps DoctorSnippetViewSet under
// /api/doctors/my-snippets/.
//
// Each clinician's snippets are private. The backend scopes queryset to
// request.user, so a list request only returns the caller's own rows;
// the user FK is injected server-side on create and cannot be set from
// the client.
// ============================================================================

import { api } from './client.js'
import { unwrapList } from '../utils/format.js'

const URL = '/api/doctors/my-snippets/'

/**
 * listMySnippets({ section })
 * Returns the caller's active personal snippets, optionally restricted
 * to a single CNE section letter (A-R).
 */
export async function listMySnippets({ section } = {}) {
  const params = {}
  if (section) params.section_code = section
  const { data } = await api.get(URL, { params })
  return unwrapList(data)
}

/**
 * createMySnippet({ title, body, section_code, category? })
 * Creates a new personal snippet under the caller's name. The user FK
 * is injected server-side from request.user; do not pass it.
 */
export async function createMySnippet(payload) {
  const body = {
    title: (payload.title || '').trim(),
    body: (payload.body || '').trim(),
    section_code: payload.section_code,
    category: payload.category || 'My Snippets',
    is_active: true,
  }
  const { data } = await api.post(URL, body)
  return data
}

/**
 * updateMySnippet(id, patch)
 * Partial-updates one of the caller's own snippets. Backend 404s if the
 * snippet isn't owned by request.user (queryset is pre-filtered).
 */
export async function updateMySnippet(id, patch) {
  const { data } = await api.patch(`${URL}${id}/`, patch)
  return data
}

/**
 * deleteMySnippet(id)
 * Hard-deletes one of the caller's own snippets. For soft-hide instead,
 * use updateMySnippet(id, { is_active: false }).
 */
export async function deleteMySnippet(id) {
  await api.delete(`${URL}${id}/`)
}
